import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal }           from '@ng-bootstrap/ng-bootstrap';

import bntIcon from 'icons/bnt.svg';

import { BntDeliveryOptionModel } from './models/bnt.delivery-option';
import { GlobalCurrencyPipe }     from '../shared/pipes/global-currency.pipe';

@Component({
  selector   : 'wor-bnt-delivery-options',
  template: require('./bnt.delivery-options.component.html')
})
export class BntDeliveryOptionsComponent implements OnInit {
  @Input() options : Array<BntDeliveryOptionModel> = [];

  public bntIcon  : string = bntIcon;
  public selected : string = null;

  constructor (
    public activeModal        : NgbActiveModal,
    private globalCurrencyPipe: GlobalCurrencyPipe
  ) {}

  getLabel ( option : BntDeliveryOptionModel ) : string {
    const price = parseFloat(option.price);

    return isNaN(price)
      ? option.label
      : `${ option.label } - ${ this.globalCurrencyPipe.transform(price) }`;
  }

  ngOnInit () : void {
    this.selected = this.options.length === 1
      ? this.options[ 0 ].id
      : null;
  }

  send () : void {
    this.activeModal.close(this.options.find(option => option.id === this.selected));
  }
}
